import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import ButtonPrimary from "../../../../components/ButtonPrimary";
import { ArticleLimitsProps } from "./types";
import Grid, { Col, Row } from "../../../../components/Grid";
import SectionLabel from "../../../../components/SectionLabel";

import "./styles.scss";

export const ArticleLimits: FC<ArticleLimitsProps> = ({
  limitValue,
  isLoading,
  onClick,
}) => {
  const { t } = useTranslation();
  const limit = useMemo(() => {
    if (limitValue === undefined) {
      return t("n/a");
    }

    return limitValue === 0 ? `${limitValue} (${t("unlimited")})` : limitValue;
  }, [limitValue, t]);

  return (
    <section className="ams-article-limits">
      <h2 className="ams-article-limits__header">{t("articleLimits")}</h2>
      <div className="ams-article-limits__content">
        <Grid className="ams-article-limits__grid">
          <Row>
            <Col>
              <SectionLabel>{t("articleLimit")}</SectionLabel>
            </Col>
            <Col className="ams-col__value">
              <SectionLabel>
                {isLoading ? t("contentLoading") : limit}
              </SectionLabel>
            </Col>
          </Row>
        </Grid>
        <ButtonPrimary onClick={onClick}>{t("setArticleLimit")}</ButtonPrimary>
      </div>
    </section>
  );
};
